
import {
  Mixins,
  Component,
  Prop,
  Emit,
} from 'vue-property-decorator';
import {
  Pagination,
  Button,
  Dialog,
  Form,
  FormItem,
  Input,
  Progress,
  Upload,
  Link,
} from 'element-ui';
import api from '@/api/video';
import { tSearch } from '@/components/Search/index';

declare let AliyunUpload: any;

  @Component({
    components: {
      Pagination,
      tSearch,
      Button,
      Dialog,
      Form,
      FormItem,
      Input,
      Progress,
      Upload,
      Link,
    },
  })
export default class bModal extends Mixins() {
    @Prop({
      default: false,
      required: true,
    }) show!: boolean;

    private visible:boolean = this.show;

    private form: any = {
      title: '',
      description: '',
      fileSuffix: '',
    }

    private fileName: string = '';

    private rules: any = {
      title: [
        { required: true, message: '请输入视频标题', trigger: 'blur' },
      ],
    }

    private progressFlag: boolean = false;

    private uploadStatus: string = '上 传';

    private videoId: string = '';

    private uploadAddress: string = '';

    private uploadAuth: string = '';

    private timeout:string = '';

    private partSize:string = '';

    private parallel:string = '';

    private retryCount:string = '';

    private retryDuration:string = '';

    private file: any = null;

    private authProgress:number = 0;

    private uploadDisabled:boolean = true;

    private resumeDisabled:boolean = true;

    private pauseDisabled:boolean = true;

    private uploader:any = null;

    private statusText:string = '';

    private isUploading: boolean = false;

    public $refs!: {
      form: Form,
      upload: Upload,
    };

    /**
     * @author niuhong
     * @desc 文件上传前事件
     */
    handleBeforeUpload(file: File) {
      const data: any = new FormData();
      data.append('file', file);
      this.file = file;
      if (!this.file) {
        alert('请先选择需要上传的文件!');
        return;
      }
      const exts = file.name.split('.')[1];
      this.fileName = file.name;
      this.form.fileSuffix = `.${exts}`;
      const Title = this.file.name;
      const userData = '{"Vod":{}}';
      if (this.uploader) {
        this.authProgress = 0;
        this.statusText = '';
      }
      if (this.isUploading) {
        this.uploader.stopUpload();
      }
      this.uploader = this.createUploader();
      // console.log(userData);
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = true;
      // if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi',
      // 'video/wmv', 'video/rmvb'].indexOf(file.type) === -1) {
      //   this.msg('格式错误，请选择正确的视频', 'warning');
      // } else {
      // }
    }

    authUpload() {
      // 然后调用 startUpload 方法, 开始上传
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          if (this.uploader !== null) {
            this.progressFlag = true;
            this.uploadStatus = '正在上传';
            this.uploader.startUpload();
            this.uploadDisabled = true;
            this.pauseDisabled = false;
          }
        } else {
          return false;
        }
        return true;
      });
    }

    // // 暂停上传
    // pauseUpload() {
    //   if (this.uploader !== null) {
    //     this.uploader.stopUpload();
    //     this.resumeDisabled = false;
    //     this.pauseDisabled = true;
    //   }
    // }
    //
    // // 恢复上传
    // resumeUpload() {
    //   if (this.uploader !== null) {
    //     this.uploader.startUpload();
    //     this.resumeDisabled = true;
    //     this.pauseDisabled = false;
    //   }
    // }

    createUploader() {
      const self = this;
      const uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        // region: self.region,
        // userId: self.userId,
        // 添加文件成功
        addFileSuccess(uploadInfo:any) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = '添加文件成功, 等待上传...';
          // console.log(`addFileSuccess:${uploadInfo.file.name}`);
        },
        // 开始上传
        onUploadstarted(uploadInfo:any) {
          if (!uploadInfo.videoId) {
            api.createVideo(self.form).then((res: any) => {
              self.isUploading = true;
              const uploadAuth1 = res.uploadAuth;
              const uploadAddress1 = res.uploadAddress;
              const videoId1 = res.videoId;
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth1, uploadAddress1, videoId1);
            }).catch((err: any) => {
              self.$refs.upload.clearFiles();
              self.isUploading = false;
              self.fileName = '';
              self.progressFlag = false;
              self.uploadStatus = '上传';
            });
            self.statusText = '文件开始上传...';
            // console.log(`onUploadStarted:${uploadInfo.file.name},
            // endpoint:${uploadInfo.endpoint}, bucket:${uploadInfo.bucket},
            // object:${uploadInfo.object}`);
          } else {
            api.refreshVideo(uploadInfo.videoId).then((res:any) => {
              const uploadAuth1 = res.uploadAuth;
              const uploadAddress1 = res.uploadAddress;
              const videoId1 = res.videoId;
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth1, uploadAddress1, videoId1);
            });
          }
        },
        // 文件上传成功
        onUploadSucceed(uploadInfo:any) {
          // console.log(`onUploadSucceed: ${uploadInfo.file.name},
          // endpoint:${uploadInfo.endpoint},bucket:${uploadInfo.bucket},
          // object:${uploadInfo.object}`);
          self.statusText = '文件上传成功!';
          const data = {
            videoId: uploadInfo.videoId,
            title: self.form.title,
            cateId: '',
            description: self.form.description,
            fileSuffix: self.form.fileSuffix,
          };
          api.saveCreateVideo(data).then((res: any) => {
            this.progressFlag = false;
            self.$emit('update:show', false);
            self.$emit('getVideoData');
          }).catch((res: any) => {
            this.progressFlag = false;
            this.uploadDisabled = '上传';
          });
        },
        // 文件上传失败
        onUploadFailed(uploadInfo:any, code:any, message:any) {
          // console.log(`onUploadFailed: file:${uploadInfo.file.name},code:${code},
          // message:${message}`);
          self.statusText = '文件上传失败!';
        },
        // 取消文件上传
        onUploadCanceled(uploadInfo:any, code:any, message:any) {
          // console.log(`Canceled file: ${uploadInfo.file.name},
          // code: ${code}, message:${message}`);
          self.statusText = '文件已暂停上传';
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress(uploadInfo:any, totalSize:any, progress:any) {
          // console.log(`onUploadProgress:file:${uploadInfo.file.name},
          // fileSize:${totalSize}, percent:${Math.ceil(progress * 100)}%`);
          self.isUploading = progress !== 1;
          const progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.statusText = '文件上传中...';
        },
        // 上传凭证超时
        onUploadTokenExpired(uploadInfo:any) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // axios.get(refreshUrl).then(({ data }:any) => {
          //   const uploadAuth = data.UploadAuth;
          //   uploader.resumeUploadWithAuth(uploadAuth);
          //   console.log(`upload expired and resume upload with uploadauth ${uploadAuth}`);
          // });
          api.refreshVideo(uploadInfo.videoId).then((res:any) => {
            const uploadAuth1 = res.uploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth1);
          });
          self.statusText = '文件超时...';
        },
        // 全部文件上传结束
        onUploadEnd(uploadInfo:any) {
          self.statusText = '文件上传完毕';
        },
      });
      return uploader;
    }

    dialogClose() {
      this.$emit('update:show', false);
    }

    resetForm() {
      this.$refs.form.resetFields();
      this.uploadDisabled = true;
      this.fileName = '';
      this.file = null;
    }
}
